import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { MainPage } from './components/MainPage';
import { PagoIncorrecto } from './components/PagoIncorrecto';
import { PagoCorrecto } from './components/PagoCorrecto';
import { Trayecto } from './components/Trayecto';
import { ErrorPage } from './components/ErrorPage';
import { CartPage } from './components/CartPage';

export const Routes: React.FC = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path='/:id' component={MainPage} />
                <Route exact path='/payment/success' component={PagoCorrecto} />
                <Route exact path='/payment/error' component={PagoIncorrecto} />
                <Route exact path='/trayecto/:id/:id_operationLine' component={Trayecto}/>
                <Route exact path='/error/:message/:id_bu' component={ErrorPage} />
                <Route exact path='/cart/:id_bu' component={CartPage} />
            </Switch>
        </BrowserRouter>
    );
};